import { Box, Link, Typography } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { RouterLink } from "lib/routes/router-link"
import { ListItemBox } from "lib/@components/ListItemBox"
import { useTreeItem } from "routes/schedule/lib/useTreeItem"
import { handleUnlicensedContent } from "routes/schedule/lib/handle-unlicensed-content"
import { ScheduleCommentIndicator } from "routes/schedule/plugins/share-link-comments/share-link-comment-schedule-indicator"

export function ScheduleAssetTitle({ stats }) {
    const { LinkComponent = Link, scheduleProfileRoute } = useBoundContext()
    const schedule = useTreeItem(stats?.id)
    const isScheduleNotLicensed = schedule?.notLicensed || schedule?.$?.notLicensed
    const to = getRoute()
    const displayTitle = truncateScheduleAssetTitle(getScheduleAssetDisplayTitle({ schedule, stats }))

    return (
        <Box display="flex" flexDirection="column" alignItems="stretch" data-cy="schedule-asset-title">
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {stats.where}
            </Typography>
            <LinkComponent component={RouterLink} to={to} onClick={handleOpen}>
                <ListItemBox
                    data-cy="schedule-asset-title-row"
                    sx={{
                        py: 0,
                        color: isScheduleNotLicensed ? "unlicensed.dark" : undefined,
                    }}
                >
                    <Typography variant="body2">{displayTitle}</Typography>
                    <Box flex={1} />
                    <ScheduleCommentIndicator schedule={schedule} schedulePath={stats.id} />
                    <Box ml={1}>{stats.code}</Box>
                </ListItemBox>
            </LinkComponent>
        </Box>
    )

    function handleOpen(e) {
        handleUnlicensedContent(schedule, e)
    }

    function getRoute() {
        if (scheduleProfileRoute) {
            return scheduleProfileRoute({ stats, schedule })
        }

        return `/app/schedules/${stats.id}`
    }
}

export function getScheduleAssetDisplayTitle({ schedule, stats }) {
    for (const candidate of [
        schedule?.label,
        schedule?.title,
        schedule?._schedule?.title,
        stats?.schedule?.title,
        stats?.title,
    ]) {
        if (candidate) return `${candidate}`
    }
    return ""
}

function truncateScheduleAssetTitle(title) {
    if (typeof title.truncate === "function") return title.truncate(55, false)
    if (title.length <= 55) return title
    return title.slice(0, 55)
}
